import React, { useState, useEffect } from 'react';
import CloseButton from '../../../../../sharecomponents/CloseButton';
import VainillaDialog from '../../../../../sharecomponents/vanilladialog';
import { activeDialog } from '../../../../../../utils/Common';
import Post from '../../../../../../utils/Post';

const EditorRancho = (p) => {
    console.log(`p`, p.data, p.ranchos);
    const ranchos = p.ranchos ?? [];
    const [dialog, setdialog] = useState({ show: false });
    const [loader, setloader] = useState(false);
    const [data, setdata] = useState({
        id: p.data.id ?? null,
        nombre: p.data.nombre ?? "",
    });
    const close = p.close ?? (() => { });
    const containerStyle = "form-group bw-350 mt-2 mb-2";

    const change = (e) => {
        let { name, value } = e.target;
        let ndata = { ...data };
        ndata[name] = value;
        if (['largo', 'no_camas'].includes(name) && ndata.largo !== "" && ndata.no_camas !== "") ndata.totalm2 = +ndata.largo * ndata.no_camas;
        setdata(ndata);
    }

    const eliminarConfimacion = () => {
        setdialog({
            tipo: "error",
            show: true,
            title: "CONFIRME PARA CONTINUAR",
            body: "¿Realmente desea eliminar la valvula?",
            respYes: "Si, eliminar",
            respNot: "Cancelar",
            funct: (resp) => { if (resp) eliminar(); setdialog({ show: false }) },
            size: 'm'
        });
    }

    const eliminar = async () => {
        let resp = await Post('catalogos/ranchos/delete', { id: data.id }, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Ocurrió un error');
            return;
        }
        close(true);
    }

    const actualizar = async () => {
        if (data.nombre === "") {
            activeDialog(setdialog, 'Agregue un nombre para el rancho', 'error', 'Error');
            return;
        }
        let resp = await Post('catalogos/ranchos/add', data, 'POST', setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Ocurrió un error');
            return;
        }
        close(true);
    }


    return (
        <div className='vw-100 vh-100 fixed blur-xl bw-white4 overflow' style={{ zIndex: 10, top: 0, left: 0 }}>
            <CloseButton close={() => close(false)} />
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='bw-300 mt-2 bg-white3 border shadow round-xxl text-center text-300 h4'>{data.id ? "EDICIÓN DE RANCHO" : "CREACIÓN DE RANCHO"}</div>
                <div className='w-100 m-0 p-0'></div>
                <div className='bw-800 p-2 round-m bg-white shadow-multi m-0'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='w-100 mt-4 text-center text-bold mb-0 p-0 text-l'>{data.id ? "EDICIÓN DE RANCHO" : "NUEVO RANCHO"}</div>
                        <div className='bw-400 border-bottom border-warning m-0 p-0'></div>
                        <div className='w-100'></div>
                        <div className='form-group bw-350 mt-3 p-0'>
                            <label className='text-bold'>NOMBRE</label>
                            <input type="text" name='nombre' value={data.nombre} className='form-control border shadow' autoComplete='off' onChange={change} />
                        </div>


                        <div className='w-100 mt-4'></div>
                        {data.id && <div className='bw-200 m-0 p-0'>
                            <button className='btn btn-danger shadow w-100 round-xxl border border-dark text-bold tex-l'
                                onClick={eliminarConfimacion}
                            >Eliminar rancho</button>
                        </div>}
                        <div className='w-100'></div>
                        <div className='bw-400 mt-4 mb-3 ms-0 me-0'>
                            <button className='btn btn-warning shadow w-100 round-xxl border border-dark text-bold tex-l'
                                onClick={actualizar}
                            >{data.id ? 'Guardar cambios' : "Agregar"}</button>
                        </div>
                    </div>
                </div>
            </div>
            <VainillaDialog data={dialog} />
            {loader && <div className='vw-100 vh-100 blur-l bg-white4' style={{ position: "fixed", top: 0, left: 0 }}>
                <div className='loader'></div>
            </div>}
        </div>
    )
}

export default EditorRancho;